import React from 'react';
// MUI
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
// Project
import { getUnitDetails, roundNumber } from '../../../../utils/functions';

export default function Header(props) {
  const { t } = useTranslation();
  const { lot, objects, history } = props;

  const { unitCode, unitName } = getUnitDetails(objects.accounts);

  return (
    <Grid item container spacing={3}>
      <Grid item xs={12} sm={6}>
        <Card>
          <CardContent>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography>{`${t('Quantity').toUpperCase()}: ${roundNumber(lot?.quantity || 0) || ''
                  } ${unitCode.toUpperCase()}`}</Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography>{`${t('Product').toUpperCase()}: ${lot?.product()?.name || ''}`}</Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography>{`${t('Container').toUpperCase()}: ${lot?.packagingType()?.name || ''} (${lot?.packagingType()?.weight || 0
                  } ${unitCode.toUpperCase()})`}</Typography>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Card>
          <CardContent>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography>{`${t('Species').toUpperCase()}: ${lot?.fruit()?.name || ''}`}</Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography>{`${t('Variety').toUpperCase()}: ${lot?.variety()?.name || ''}`}</Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography>{`${t('Warehouse').toUpperCase()}: ${lot?.warehouse()?.name || t('No warehouse')}`}</Typography>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Button
          fullWidth
          variant="outlined"
          color="primary"
          onClick={() => history.push(`process/${lot?.originProcess()?.id}`)}>
          {t('Origin process')} {lot?.originProcess()?.id} {lot?.originProcess()?.processType()?.name || ''}
        </Button>
      </Grid>
      <Grid item xs={12} sm={6}>
        {lot?.destinyProcess() && (
          <Button
            fullWidth
            variant="outlined"
            color="primary"
            onClick={() => history.push(`process/${lot?.destinyProcess()?.id}`)}>
            {t('Destiny process title', {
              id: lot?.destinyProcess()?.id || '',
              name: lot?.destinyProcess()?.processType()?.name || '',
            })}
          </Button>
        )}
      </Grid>
    </Grid>
  );
}
